export default __webpack_public_path__ + "static/media/vitiligo-surgery.2e58d4b0.JPG";